<cm-table-layout>
    <cm-organization-groups-table></cm-organization-groups-table>
</cm-table-layout>

<router-outlet></router-outlet>
